import { connect } from 'react-redux'
import PupilsFilterDialog from './pupils-filter-dialog'
import { getFilterDialogOpened } from '../pupils-component-redux/pupils-component.selectors'
import { hideFilterDialog } from '../pupils-component-redux/pupils-component.actions'

const mapStateToProps = state => ({
  isOpen: getFilterDialogOpened(state)
})

const mapDispatchToProps = dispatch => ({
  requestClose: () => dispatch(hideFilterDialog())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PupilsFilterDialog)
